/**
 * Mobile betting apps — `/betting-gaming/mobile-betting-apps`
 */
import { MOBILE_BETTING_APPS_SLUG, mobileBettingAppsDefaultData } from "./mobileBettingAppsData";
import {
  MobileBettingAppsArticlesTab,
  MobileBettingAppsMediaTab,
  MobileBettingAppsOverviewTab,
} from "./MobileBettingAppsDesign";

export const mobileBettingAppsModule = {
  slug: MOBILE_BETTING_APPS_SLUG,
  getDefaultData: () => mobileBettingAppsDefaultData,
  Views: {
    overview: MobileBettingAppsOverviewTab,
    articles: MobileBettingAppsArticlesTab,
    media: MobileBettingAppsMediaTab,
  },
};
